import $ from "../../../components/jquery";
import UIkit from "uikit";
import Toast from "../../../components/toast";
import Loading from "components/loading";
import Modal from "components/modal";
import { criarGerenciadorAjustesIndice } from "../reajusteIndice/ajustes";
import "./index.less";

let aplicarUrl = "";
let concluido: (resultado: any) => void;
let ocupado = false;
const ajustes = criarGerenciadorAjustesIndice({
    listSelector: "#cliente-reajuste-igpm-ajustes-list",
    emptySelector: "#cliente-reajuste-igpm-ajustes-empty",
    addButtonSelector: "#cliente-reajuste-igpm-ajuste-adicionar",
    actionButtonSelector: ".cliente-reajuste-igpm-ajuste-acao",
    modalSelector: "#cliente-reajuste-igpm-ajuste-modal",
    formSelector: "#cliente-reajuste-igpm-ajuste-form",
    modalTitleSelector: "#cliente-reajuste-igpm-ajuste-modal .uk-modal-title",
    globalName: "clienteReajusteIgpmExcecao"
});

export function abrirExcecao(codItem: number, url: string, urlAplicar: string, onConcluido: (resultado: any) => void) {
    if (ocupado) return;
    ocupado = true;
    Loading.show("");
    $.get(url, { codItem })
        .done((html) => {
            // UIkit move os modais para body. Esvaziar o container não remove
            // esses formulários e pode deixar IDs/versões antigos na próxima abertura.
            $("#cliente-reajuste-igpm-excecao-modal, #cliente-reajuste-igpm-ajuste-modal").remove();
            let container = $("#cliente-reajuste-igpm-excecao-container");
            if (!container.length) {
                container = $("<div>", { id: "cliente-reajuste-igpm-excecao-container" }).appendTo("body");
            }
            container.empty().append(html);
            aplicarUrl = urlAplicar;
            concluido = onConcluido;
            const form = $("#cliente-reajuste-igpm-excecao-form");
            ajustes.atualizarBloqueio(form.attr("data-pode-aplicar") !== "true" || Number(form.attr("data-indice")) < 0);
            ajustes.atualizarEstado();
            const modal = $("#cliente-reajuste-igpm-excecao-modal");
            const modalAjuste = $("#cliente-reajuste-igpm-ajuste-modal");
            modal.on("hidden", (event) => {
                if (event.target === modal.get(0)) { modal.remove(); modalAjuste.remove(); }
            });
            UIkit.modal(modal.get(0), { stack: true }).show();
        })
        .fail((xhr) => Toast.error(xhr))
        .always(() => { ocupado = false; Loading.hide(); });
}

export async function aplicar() {
    const form = $("#cliente-reajuste-igpm-excecao-modal.uk-open").find("#cliente-reajuste-igpm-excecao-form");
    if (ocupado || form.attr("data-pode-aplicar") !== "true" || !aplicarUrl) return;
    ocupado = true;
    const confirmado = await Modal.confirm("Aplicar a exceção individual e recalcular as cobranças desde o início da competência original?", "Aplicar", "Cancelar");
    if (!confirmado) { ocupado = false; return; }
    Loading.show("");
    $("#cliente-reajuste-igpm-excecao-aplicar").prop("disabled", true);
    $.post({ url: aplicarUrl, data: form.serialize(), global: false })
        .done((resultado) => {
            UIkit.modal("#cliente-reajuste-igpm-excecao-modal").hide();
            Toast.success("Exceção individual aplicada. Cobranças recalculadas na competência original.");
            concluido?.(resultado);
        })
        .fail((xhr) => Toast.error(xhr))
        .always(() => {
            ocupado = false;
            $("#cliente-reajuste-igpm-excecao-aplicar").prop("disabled", false);
            Loading.hide();
        });
}

// O histórico também pode ser aberto pelos valores-hora, fora da listagem de cadastros.
// Este namespace acompanha o módulo compartilhado, sem depender do bundle da listagem.
const thor = (window as any).Thor = (window as any).Thor || {};
thor.clienteReajusteIgpmExcecao = {
    aplicar,
    abrirModalAjuste: (id?: number) => ajustes.abrirModal(id),
    salvarAjuste: () => ajustes.salvarAjuste(),
    removerAjuste: (id: number) => ajustes.removerAjuste(id)
};
